"use client";

import React, { useState, useEffect, useRef } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { ArrowRight, TrendingUp } from "lucide-react";
function useOnScreen(ref: React.RefObject<HTMLElement | null>, rootMargin = "0px") {
  const [isIntersecting, setIntersecting] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIntersecting(true);
        observer.disconnect();
      }
    }, {
      rootMargin
    });
    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => {
      observer.disconnect();
    };
  }, [ref, rootMargin]);
  return isIntersecting;
}
const ValueCounter = () => {
  const [count, setCount] = useState(0);
  const ref = useRef<HTMLDivElement>(null);
  const isVisible = useOnScreen(ref, "-100px");
  const target = 485000000;
  const duration = 2500;
  useEffect(() => {
    if (!isVisible) return;
    let startTime: number | null = null;
    let animationFrameId: number;
    const animate = (timestamp: number) => {
      if (!startTime) startTime = timestamp;
      const progress = timestamp - startTime;
      const percentage = Math.min(progress / duration, 1);
      const easeOut = 1 - Math.pow(1 - percentage, 4);
      setCount(Math.floor(easeOut * target));
      if (progress < duration) {
        animationFrameId = requestAnimationFrame(animate);
      }
    };
    animationFrameId = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animationFrameId);
  }, [isVisible]);
  return <div data-section-id="60928" ref={ref} className="font-sans text-5xl md:text-7xl lg:text-8xl font-bold tracking-tighter text-[var(--color-primary)] tabular-nums">
      ${count.toLocaleString()}
    </div>;
};
export default function MaximizeYourValue() {
  return <section id="market-news" className="relative w-full min-h-[85vh] flex items-center justify-center overflow-hidden bg-[var(--color-background)] text-[var(--color-foreground)]">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1608256/img/orlando_skyline_daylight.png)] bg-cover bg-center bg-no-repeat" />
        <div className="absolute inset-0 bg-linear-to-b from-black/60 via-black/30 to-black/60" />
      </div>

      {}
      
    </section>;
}